import { trace } from '@opentelemetry/api';
import type { Span } from '@opentelemetry/api';

export const runWithSpan = async <T>(name: string, execute: (span: Span) => Promise<T>): Promise<T> => {
  const tracer = trace.getTracer('ui.api');
  return tracer.startActiveSpan(name, async span => {
    try {
      return await execute(span);
    } finally {
      span.end();
    }
  });
};
